import React from "react";
import { ExternalLink, Newspaper } from "lucide-react";

const pressItems = [
  {
    title: "Patented Nigerian Food Innovation Targets Hunger, Food Waste, Climate Challenges",
    outlet: "Eagles Watch Online",
    type: "Featured Article",
    image: "media/newspaper2026.jpeg",
    url: "https://eagleswatchonline.com.ng/patented-nigerian-food-innovation-targets-hunger-food-waste-climate-challenges",
    description:
      "A spotlight on how FIGHN Africa's multi-mix functional food flours address malnutrition, reduce food loss, and lower carbon footprints.",
  },
];

function Press() {
  return (
    <section id="press" className="max-w-6xl mx-auto px-6 sm:px-8 py-16 sm:py-24">
      <div className="max-w-xl mb-12 sm:mb-16">
        <p className="text-grain font-semibold text-xs uppercase tracking-[0.2em] mb-3">
          Media & Recognition
        </p>
        <h2 className="font-display text-3xl sm:text-4xl text-forest mb-3">
          As Seen In The Press
        </h2>
        <p className="text-ink/70">
          Discover how our innovations in sustainable food processing and nutrition are making headlines.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 items-stretch">
        {pressItems.map((item, index) => (
          <div
            key={index}
            className="group flex flex-col justify-between rounded-2xl border border-forest/15 bg-white/40 p-6 sm:p-8 transition-all duration-300 hover:border-forest/40 hover:shadow-lg"
          >
            <div>
              
              <div className="relative mb-6 rounded-xl overflow-hidden aspect-[16/9] border border-forest/10 bg-forest/5">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 right-3 bg-forest text-canvas text-xs font-semibold px-3 py-1 rounded-full shadow-md backdrop-blur">
                  {item.type}
                </span>
              </div>

              
              <div className="flex items-center gap-2 text-xs font-medium text-grain uppercase tracking-wider mb-2">
                <Newspaper className="w-4 h-4 text-forest" />
                <span>{item.outlet}</span>
              </div>

              
              <h3 className="font-display text-xl sm:text-2xl text-forest mb-3 leading-snug group-hover:text-forest-dark transition-colors">
                {item.title}
              </h3>

              
              <p className="text-ink/70 text-sm leading-relaxed mb-6">
                {item.description}
              </p>
            </div>

            
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-forest text-canvas text-sm font-semibold px-6 py-3 rounded-full hover:bg-forest-dark transition-colors w-full sm:w-auto self-start"
            >
              <span>Read Full Article</span>
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Press;